/*@ngInject*/
const SubmissionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.closeSubmission = function (submissionId) {
        const url = `/rest/Submission/${submissionId}/List?registrationIdentifier=/Submission/${submissionId}`;

        return this.delete(url);
    };

    this.createSubmission = function () {
        const url = '/rest/Submission/create';

        return this.post(url);
    };

    this.deleteSubmission = function (submissionId) {
        const url = '/rest/Submission/' + submissionId;

        return this.delete(url);
    };

    this.submitSubmission = function (submissionId) {
        const url = `/rest/Submission/${submissionId}/submit`,
            config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    };

    this.setSubmissionOpenHistory = function (submissionId, userId) {
        const url = '/rest/SubmissionOpenHistory',
            config = {
                params: {
                    submissionId: submissionId,
                    userId: userId
                }
            };
        return this.post(url, {}, config);
    };

    this.updateSubmission = function (submissionId, submissionPropertiesMap) {
        const url = `/rest/Submission/${submissionId}`,
            config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, submissionPropertiesMap, config);
    }

    this.getSubmissionTransactions = function (submissionId) {
        const url = `/rest/Submission/${submissionId}/SubmissionTransactions/`;
        return this.get(url);
    }

    this.isUserAuthorizedForSubmissionProduct = function (submissionId) {
        const url = `/rest/Submission/${submissionId}/productAuthorization`;
        return this.get(url);
    };

};

angular.module('gw-um-submission')
    .service('submissionRepository', SubmissionRepository);
